// extracted by mini-css-extract-plugin
export default {"titleBlock":"title-block_titleBlock__0j1fj"};